
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:root{
  --global-width:1200px;
}

.home .our-states,
  .highlevel .our-states{
    padding:0 16px;
  }

@media (min-width: 1024px){

.home .our-states,
  .highlevel .our-states{
      padding:0 calc(5% - 8px)
  }
    }

.our-states__wrapper{
    margin:0 auto;
    max-width:calc(1200px - 16px);
    max-width:calc(var(--global-width) - 16px);
    position:relative;
  }

.our-states__content .btn{
      display:none;
    }

@media (min-width: 1024px){

.our-states__content .btn{
        display:inline-block
    }
      }

.our-states__container{
    margin-top:30px;
    padding-bottom:calc(519 / 839 * 100%);
    position:relative;
  }

.our-states__map{
    bottom:0;
    height:100%;
    left:0;
    position:absolute;
    right:0;
    top:0;
    width:100%;
  }

.our-states__map:not(.our-states__map--has-loc-pins){
      display:none;
    }

@media (min-width: 1024px){
      .our-states__map:not(.our-states__map--has-loc-pins){
        display:block;
      }
    }

@media (min-width: 1024px){

.our-states path[data-name='Rule']{
      display:none
  }
    }

.our-states--large .our-states__content:before{
      background:rgb(255, 255, 255);
      background:linear-gradient(
        90deg,
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 0) 100%
      );
      content:'';
      display:none;
      height:100%;
      left:0;
      position:absolute;
      top:0;
      width:100%;
      z-index:-1;
    }

@media (min-width: 1280px){

.our-states--large .our-states__content .user-markup{
        max-width:410px
    }
      }

@media (min-width: 1280px){

.our-states--large .our-states__content{
      display:flex;
      flex-direction:column;
      left:0;
      max-width:308px;
      min-height:600px;
      position:absolute;
      padding-top:80px;
      top:0;
      z-index:1
  }

      .our-states--large .our-states__content:before{
        display:block;
      }
    }

@media (min-width: 1280px){

.our-states--large .our-states__container{
      margin-top:0;
      padding-bottom:calc(691 / 1118 * 100%)
  }
    }

@media (min-width: 1280px){

.our-states--large{
    padding-left:158px;
    padding-top:10px
}
  }

.our-states--alt .our-states__content:before, .our-states--alt .our-states--large .our-states__content:before{
        background-image:linear-gradient(
          90deg,
          rgba(var(--brand-dark-blue), 1) 0%,
          rgba(var(--brand-dark-blue), 0) 100%
        );
      }

.our-states--alt .our-states__content .user-markup{
      color:var(--outline-white);
    }

.accordion-wrapper{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-4);
}

@media (min-width: 1024px){

.accordion-wrapper{
    display:none
}
  }
`;